<template>
	<input ref="input" type="date" :value="value" @input="onInput" @click="openPicker" :min="min"
		:class="['date-input', { 'full-width': fullWidth }]" />
</template>

<script>
export default {
	name: "DateInput",

	model: {
		prop: "value",
		event: "input"
	},

	props: {
		value: {
			type: String,
			default: ""
		},
		min: {
			type: String,
			default: ""
		},
		fullWidth: {
			type: Boolean,
			default: false
		}
	},

	methods: {
		onInput(e) {
			this.$emit("input", e.target.value)
		},
		openPicker() {
			const input = this.$refs.input

			if (input.showPicker) {
				input.showPicker() // Chrome, Edge
			} else {
				input.focus() // Safari fallback

				// Try to simulate user interaction
				const event = new KeyboardEvent("keydown", {
					key: "ArrowDown",
					bubbles: true
				})
				input.dispatchEvent(event)
			}
		}
	}
}
</script>

<style scoped>
.date-input {
	padding: 0.5rem 0;
	border: none;
	background: transparent;
	outline: none;
	cursor: pointer;
}

.full-width {
	width: 100%;
}

/* Fix cursor on calendar icon (Chrome/Edge) */
.date-input::-webkit-calendar-picker-indicator {
	cursor: pointer;
}
</style>